import _slicedToArray from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useState } from "react";
import { default as _Form } from "react-jsonschema-form";
import CustomSelect from "./CustomSelect";
import classNames from "classnames";
import { Icon, CustomInput } from "../..";
import { Button } from "../..";
import { ICONS } from "../..";
/**
 * CustomDescriptionField
 */

var CustomDescriptionField = function CustomDescriptionField(_ref) {
  var id = _ref.id,
      description = _ref.description;
  return React.createElement("small", {
    className: "form-text text-muted"
  }, description);
};
/**
 * CustomFieldTemplate is a form row stateless component
 * https://react-jsonschema-form.readthedocs.io/en/latest/advanced-customization/#custom-descriptions
 */


var CustomFieldTemplate = function CustomFieldTemplate(props) {
  var id = props.id,
      classNames = props.classNames,
      displayLabel = props.displayLabel,
      label = props.label,
      rawHelp = props.rawHelp,
      help = props.help,
      required = props.required,
      description = props.description,
      errors = props.errors,
      children = props.children;
  return React.createElement("div", {
    className: classNames
  }, displayLabel && React.createElement("label", {
    htmlFor: id,
    className: "form-input-label"
  }, label, required ? "*" : null), children, displayLabel && description ? description : null, errors, rawHelp ? React.createElement("small", {
    className: "form-text text-muted"
  }, props.rawHelp) : help);
};

var CustomBase = function CustomBase(props) {
  // Note: since React 15.2.0 we can't forward unknown element attributes, so we
  // exclude the "options" and "schema" ones here.
  if (!props.id) {
    console.log("No id for", props);
    throw new Error("no id for props ".concat(JSON.stringify(props)));
  }

  var value = props.value,
      readonly = props.readonly,
      disabled = props.disabled,
      autofocus = props.autofocus,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      schema = props.schema,
      options = props.options,
      formContext = props.formContext,
      inputProps = __rest(props, ["value", "readonly", "disabled", "autofocus", "onBlur", "onFocus", "schema", "options", "formContext"]); // If options.inputType is set use that as the input type


  if (options.inputType) {
    inputProps.type = options.inputType;
  } else if (!inputProps.type) {
    // If the schema is of type number or integer, set the input type to number
    if (schema.type === "number") {
      inputProps.type = "number"; // Setting step to 'any' fixes a bug in Safari where decimals are not
      // allowed in number inputs

      inputProps.step = "any";
    } else if (schema.type === "integer") {
      inputProps.type = "number"; // Since this is integer, you always want to step up or down in multiples
      // of 1

      inputProps.step = "1";
    } else {
      inputProps.type = "text";
    }
  } // If multipleOf is defined, use this as the step value. This mainly improves
  // the experience for keyboard users (who can use the up/down KB arrows).


  if (schema.multipleOf) {
    inputProps.step = schema.multipleOf;
  }

  var _onChange = function _onChange(_ref2) {
    var value = _ref2.target.value;
    return props.onChange(value === "" ? options.emptyValue : value);
  };

  var inputClassName = classNames("input-group", {
    "is-required": props.required
  });
  return React.createElement("div", {
    className: inputClassName
  }, React.createElement("input", Object.assign({
    className: "form-control",
    readOnly: readonly,
    disabled: disabled,
    autoFocus: autofocus,
    value: value == null ? "" : value
  }, inputProps, {
    onChange: _onChange,
    onBlur: onBlur && function (event) {
      return onBlur(inputProps.id, event.target.value);
    },
    onFocus: onFocus && function (event) {
      return onFocus(inputProps.id, event.target.value);
    }
  })));
};

function ArrayFieldTitle(_ref3) {
  var TitleField = _ref3.TitleField,
      idSchema = _ref3.idSchema,
      title = _ref3.title,
      required = _ref3.required;

  if (!title) {
    return null;
  }

  var id = "".concat(idSchema.$id, "__title");
  return React.createElement(TitleField, {
    id: id,
    title: title,
    required: required
  });
}

function ArrayFieldDescription(_ref4) {
  var DescriptionField = _ref4.DescriptionField,
      idSchema = _ref4.idSchema,
      description = _ref4.description;

  if (!description) {
    return null;
  }

  var id = "".concat(idSchema.$id, "__description");
  return React.createElement(DescriptionField, {
    id: id,
    description: description
  });
}

function ArrayFieldTemplate(props) {
  return React.createElement("fieldset", {
    className: props.className,
    id: props.idSchema.$id
  }, React.createElement(ArrayFieldTitle, {
    key: "array-field-title-".concat(props.idSchema.$id),
    TitleField: props.TitleField,
    idSchema: props.idSchema,
    title: props.uiSchema["ui:title"] || props.title,
    required: props.required
  }), (props.uiSchema["ui:description"] || props.schema.description) && React.createElement(ArrayFieldDescription, {
    key: "array-field-description-".concat(props.idSchema.$id),
    DescriptionField: props.DescriptionField,
    idSchema: props.idSchema,
    description: props.uiSchema["ui:description"] || props.schema.description
  }), React.createElement("div", {
    className: "array-item-list",
    key: "array-item-list-".concat(props.idSchema.$id)
  }, props.items && props.items.map(function (p) {
    return DefaultArrayItem(p);
  })), props.canAdd && React.createElement(AddButton, {
    onClick: props.onAddClick,
    disabled: props.disabled || props.readonly
  }));
}

function DefaultArrayItem(props) {
  var btnStyle = {
    flex: 1,
    paddingLeft: 6,
    paddingRight: 6,
    fontWeight: "bold"
  };
  return React.createElement("div", {
    key: props.key,
    className: props.className,
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, React.createElement("div", {
    style: {
      flex: 1,
      marginRight: 8
    }
  }, props.children), props.hasToolbar && React.createElement("div", {
    className: "array-item-toolbox"
  }, React.createElement("div", {
    className: "btn-group",
    style: {
      display: "flex",
      justifyContent: "space-around"
    }
  }, (props.hasMoveUp || props.hasMoveDown) && React.createElement(IconButton, {
    icon: ICONS.ARROW_UP,
    tabIndex: "-1",
    style: btnStyle,
    disabled: props.disabled || props.readonly || !props.hasMoveUp,
    onClick: props.onReorderClick(props.index, props.index - 1)
  }), (props.hasMoveUp || props.hasMoveDown) && React.createElement(IconButton, {
    icon: ICONS.ARROW_DOWN,
    tabIndex: "-1",
    style: btnStyle,
    disabled: props.disabled || props.readonly || !props.hasMoveDown,
    onClick: props.onReorderClick(props.index, props.index + 1)
  }), props.hasRemove && React.createElement(IconButton, {
    color: "danger",
    icon: ICONS.DELETE,
    tabIndex: "-1",
    style: btnStyle,
    disabled: props.disabled || props.readonly,
    onClick: props.onDropIndexClick(props.index)
  }))));
}

var AddButton = function AddButton(props) {
  return React.createElement(IconButton, Object.assign({}, Object.assign(Object.assign({}, props), {
    icon: ICONS.PLUS_CIRCLE
  })));
};

var IconButton = function IconButton(_a) {
  var children = _a.children,
      icon = _a.icon,
      props = __rest(_a, ["children", "icon"]);

  return React.createElement(Button, Object.assign({}, props), React.createElement(Icon, {
    size: 16,
    icon: icon,
    className: "mx-auto"
  }, children));
};

function RadioWidget(props) {
  var options = props.options,
      value = props.value,
      required = props.required,
      disabled = props.disabled,
      readonly = props.readonly,
      _props$autofocus = props.autofocus,
      autofocus = _props$autofocus === void 0 ? false : _props$autofocus,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      _onChange2 = props.onChange,
      id = props.id; // Generating a unique field name to identify this set of radio buttons

  var name = Math.random().toString();
  var enumOptions = options.enumOptions,
      enumDisabled = options.enumDisabled,
      inline = options.inline; // checked={checked} has been moved above name={name}, As mentioned in #349;
  // this is a temporary fix for radio button rendering bug in React, facebook/react#7630.

  return React.createElement("div", {
    className: "field-radio-group",
    id: id
  }, enumOptions.map(function (option, i) {
    var checked = option.value === value;
    var itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) != -1;
    var disabledCls = disabled || itemDisabled || readonly ? "disabled" : "";
    var radio = React.createElement("span", null, React.createElement(CustomInput, {
      type: "radio",
      id: id + "#" + option.value,
      checked: checked,
      name: name,
      required: required,
      value: option.value,
      disabled: disabled || itemDisabled || readonly,
      autoFocus: autofocus && i === 0,
      onChange: function onChange(_) {
        return _onChange2(option.value);
      },
      onBlur: onBlur && function (event) {
        return onBlur(id, event.target.value);
      },
      onFocus: onFocus && function (event) {
        return onFocus(id, event.target.value);
      },
      label: option.label
    }));
    return inline ? React.createElement("label", {
      key: i,
      className: "radio-inline ".concat(disabledCls)
    }, radio) : React.createElement("div", {
      key: i,
      className: "radio ".concat(disabledCls)
    }, React.createElement("label", null, radio));
  }));
}
/*
 * widgets maps react-jsonschema-form widgets to our own custom components
 */


var widgets = {
  // SelectWidget has multiple and options props which are not in Widget type...
  SelectWidget: CustomSelect,
  BaseInput: CustomBase,
  RadioWidget: RadioWidget
};
/*
 * fields maps react-jsonschema-form fields to our own custom components
 */

var fields = {
  DescriptionField: CustomDescriptionField
};
var defaultChild = React.createElement("button", {
  type: "submit",
  className: "btn btn-primary"
}, "Submit");
export var VSETHForm = function VSETHForm(props) {
  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      formData = _useState2[0],
      setFormData = _useState2[1];

  return React.createElement(_Form, Object.assign({
    formData: formData,
    onChange: function onChange(d) {
      return setFormData(d.formData);
    },
    children: defaultChild,
    FieldTemplate: CustomFieldTemplate,
    ArrayFieldTemplate: ArrayFieldTemplate
  }, props, {
    widgets: Object.assign(Object.assign({}, props.widgets), widgets),
    fields: Object.assign(Object.assign({}, props.fields), fields)
  }));
};